"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Alert;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.constants");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.tagging");

require("./Alert.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Alert(_ref) {
  let {
    errorToPrint,
    taggingInfo,
    iconColor,
    iconId
  } = _ref;
  const {
    title,
    msg,
    secondaryMessage,
    phone,
    link,
    buttons
  } = errorToPrint;

  const mobileDisplay = (0, _gerenciatdUtils.getDeviceKindDependsOnViewPort)() === _gerenciatdUtils2.DEVICES.MOBILE;

  const makePhoneCall = () => {
    window.open(`tel:${phone}`);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "AlertContainer container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
      id: iconId,
      color: iconColor,
      kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT,
      size: 64
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
      className: "AlertContainer__title",
      level: _gerenciatdUnifiedcomponents3.HEADING_LEVEL.H2,
      kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.HEADING,
      align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
      color: _gerenciatdUnifiedcomponents3.COLOR.GREY_6,
      size: _gerenciatdUnifiedcomponents3.SIZE.TITLE4,
      fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.LIGHT,
      text: title
    }), msg && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "AlertContainer__msg",
      children: msg.map((text, index) => {
        const keyId = `stopper-alert-msg-${index}-${text}`;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
          display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK,
          align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
          color: _gerenciatdUnifiedcomponents3.COLOR.GREY_4,
          size: _gerenciatdUnifiedcomponents3.SIZE.TITLE6,
          fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
          text: text
        }, keyId);
      })
    }), secondaryMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "AlertContainer__secondaryMessage",
      children: msg.map((text, index) => {
        const keyId = `stopper-alert-secondary-msg-${index}-${text}`;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
          display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK,
          align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
          color: _gerenciatdUnifiedcomponents3.COLOR.GREY_5,
          size: _gerenciatdUnifiedcomponents3.SIZE.TITLE6,
          fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
          text: text
        }, keyId);
      })
    }), phone && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "AlertContainer__phoneButton",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        color: _gerenciatdUnifiedcomponents2.BUTTON_COLOR.GREEN_REVERSE,
        buttonType: "button",
        onClick: makePhoneCall,
        label: phone,
        iconPosition: mobileDisplay ? _gerenciatdUnifiedcomponents2.ICON_POSITION.LEFT : _gerenciatdUnifiedcomponents2.ICON_POSITION.RIGHT,
        svgComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
          id: _gerenciatdUnifiedicons.ICONS_ID.Fijo,
          color: _gerenciatdUnifiedicons.COLOR.GREEN,
          kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID,
          size: 16
        }),
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: _gerenciatdUtils3.CALL_4_SELLING_CONTENT.T900
        }),
        size: {
          w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.FULL,
          h: _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.MEDIUM
        },
        desktopProps: {
          size: {
            w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.MEDIUM,
            h: _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.REGULAR
          }
        }
      })
    }), link && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "AlertContainer__linkContainer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        link: link.url,
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: link.label
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
          display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK,
          align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
          color: _gerenciatdUnifiedcomponents3.COLOR.BLUE,
          size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION2,
          fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
          text: link.label
        })
      })
    }), buttons && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "AlertContainer__buttonsContainer",
      children: buttons.map((btn, index) => {
        let desktopBtnWidth = '';
        let desktopBtnHeigh = '';

        if (btn.desktopProps && btn.desktopProps.size && btn.desktopProps.size.w && btn.desktopProps.size.h) {
          desktopBtnWidth = btn.desktopProps.size.w;
          desktopBtnHeigh = btn.desktopProps.size.h;
        }

        const keyId = `stopper-alert-btn-${index}-${btn.label}`;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
          color: btn.color,
          buttonType: "button",
          onClick: btn.onClick,
          link: btn.link,
          label: btn.label,
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: btn.label
          }),
          size: {
            w: btn.size ? btn.size.w : _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.FULL,
            h: btn.size ? btn.size.h : _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.LARGE
          },
          desktopProps: {
            size: {
              w: desktopBtnWidth || _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.MEDIUM,
              h: desktopBtnHeigh || _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.REGULAR
            }
          },
          className: "AlertContainer__buttonsContainer--button"
        }, keyId);
      })
    })]
  });
}

Alert.propTypes = {
  errorToPrint: _propTypes.default.shape({
    link: _propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }),
    title: _propTypes.default.string,
    msg: _propTypes.default.arrayOf(_propTypes.default.string),
    phone: _propTypes.default.string
  }).isRequired
};

//# sourceMappingURL=index.js.map